import { Action, ActionName } from '@app/actions/action.types';
import { NotificationData } from '@app/core/types/common/notification.types';

/**
 * Maps an incoming push-notification payload into an {@link Action} so it can be
 * dispatched through the shared actions flow (see {@link ActionBase}).
 *
 * Survey payloads arrive as separate `domain`/`token`/`parameters`/`properties`
 * fields (`parameters`/`properties` are stringified), so they are combined into
 * the single `surveyData` JSON string that `ActionSandbox.openSurvey` expects.
 */
export function mapNotificationDataToAction(data: NotificationData): Action {
  return {
    name: data.actionName,
    data: {
      documentTypeId: data.documentTypeId,
      documentId: data.documentId,
      batchId: data.batchId,
      flowId: data.flowId,
      engagementId: data.engagementId,
      shiftId: data.shiftId,
      chatAgentExternalId: data.chatAgentExternalId,
      appointmentId: data.appointmentId,
      externalId: data.externalId,
      url: data.url,
      day: data.day,
      year: data.year,
      weekNumber: data.weekNumber,
      surveyData:
        data.actionName === ActionName.OpenSurvey
          ? JSON.stringify({
              domain: data.domain,
              token: data.token,
              parameters: data.parameters ? JSON.parse(data.parameters) : {},
              properties: data.properties ? JSON.parse(data.properties) : {},
            })
          : data.surveyData,
    },
  };
}
